import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Switch } from 'react-router-dom';
import { AccountDetails } from '@components-member/TradingAccounts/AccountDetails/AccountDetails';
import { IAccountDetailsProps } from '@components-member/TradingAccounts/interfaces';
import RouteWithPageTitle from '@components-shared/RouteWithPageTitle';
import withErrorBoundary from '@components-shared/withErrorBoundary';

const TradingAccountsRoutes: React.FC = () => (
  <>
    <Switch>
      <RouteWithPageTitle
        pageTitle="Trading account details"
        path="/member/tradingaccounts/:accountId"
        render={(props: RouteComponentProps) => <AccountDetails {...(props as IAccountDetailsProps)} />}
      />
    </Switch>
  </>
);

export default withErrorBoundary(TradingAccountsRoutes);
